import { sessionEventTypeCategories, } from '@debbie/common/dist/sessions/index.js';
import * as api from './api/session-events.js';
const localStoraged = (() => {
    const local = new Map();
    const deleted = new Set();
    const getItem = (key) => {
        const localData = local.get(key);
        if (localData != null) {
            return localData;
        }
        if (deleted.has(key)) {
            return null;
        }
        return localStorage.getItem(key);
    };
    const _setItem = (key, value, persist = true) => {
        // Null means delete value
        if (value == null) {
            local.delete(key);
            deleted.add(key);
            if (persist) {
                localStorage.removeItem(key);
            }
            return;
        }
        if (deleted.has(key)) {
            deleted.delete(key);
        }
        local.set(key, value);
        if (persist) {
            localStorage.setItem(key, value);
        }
    };
    const setItem = (key, value) => _setItem(key, value, true);
    const listener = (e) => {
        if (e.storageArea !== localStorage) {
            return;
        }
        const key = e.key;
        if (key === null) {
            local.clear();
            deleted.clear();
            return;
        }
        const value = e.newValue;
        if (key != null) {
            _setItem(key, value, false);
        }
    };
    window.addEventListener('storage', listener);
    return {
        setItem,
        getItem,
    };
})();
const MAX_INACTIVE_TIME = 60 * 60 * 1000;
const memoize = (fn, recheckTime = MAX_INACTIVE_TIME) => {
    let value = null;
    let lastSet = 0;
    return () => {
        if (value != null && Date.now() < lastSet + recheckTime) {
            return value;
        }
        value = fn();
        return value;
    };
};
const getSessionId = memoize(() => {
    const session = localStoraged.getItem('sessionId');
    console.log(session);
    if (session != null) {
        // TODO: Safe parse
        const sessionContent = JSON.parse(session);
        // New session should be started on 1 hour of inactivity
        if (Date.now() < sessionContent.lastUsed + MAX_INACTIVE_TIME) {
            return sessionContent.id;
        }
        localStoraged.setItem('sessionSeq', null);
    }
    const sessionId = crypto.randomUUID();
    const now = Date.now();
    const newSession = {
        id: sessionId,
        lastUsed: now,
        createdAt: now,
    };
    localStoraged.setItem('sessionId', JSON.stringify(newSession));
    localStoraged.setItem('sessionSeq', '0');
    return sessionId;
});
const recordSessionActivity = () => {
    const sessionRaw = localStoraged.getItem('sessionId');
    if (sessionRaw == null) {
        return;
    }
    const oldSession = JSON.parse(sessionRaw);
    const now = Date.now();
    const newSession = {
        id: oldSession.id,
        lastUsed: now,
        createdAt: oldSession.createdAt,
    };
    localStoraged.setItem('sessionId', JSON.stringify(newSession));
};
const getSessionSeq = () => {
    const storedValue = localStoraged.getItem('sessionSeq');
    if (storedValue == null) {
        localStoraged.setItem('sessionSeq', '1');
        return 0;
    }
    const num = parseInt(storedValue);
    if (Number.isNaN(num)) {
        localStoraged.setItem('sessionSeq', '1');
        return 0;
    }
    localStoraged.setItem('sessionSeq', `${num + 1}`);
    return num;
};
const getTabId = memoize(() => {
    const tabId = sessionStorage.getItem('tabId');
    if (tabId != null) {
        return tabId;
    }
    const newId = crypto.randomUUID();
    sessionStorage.setItem('tabId', newId);
    return newId;
});
export const session = (() => {
    let queue = [];
    let submitting = [];
    let isSubmitting = false;
    const submitEvents = async () => {
        if (isSubmitting) {
            return;
        }
        isSubmitting = true;
        submitting = queue.slice(0, 40);
        queue = queue.slice(40);
        try {
            await api.submitEvents(submitting);
            console.log('Submitted', submitting.length, 'events');
            if (queue.length > 0) {
                setTimeout(submitEvents, 0);
            }
        }
        catch (err) {
            queue = [...submitting, ...queue];
            // TODO: if error is retryable (otherwise figure out error and try again)
            if (queue.length !== 0) {
                setTimeout(submitEvents, 1000 + Math.round(Math.random() * 4000));
            }
        }
        finally {
            submitting = [];
            isSubmitting = false;
        }
    };
    let debounceTimer = undefined;
    const submit = () => {
        if (queue.length < 40) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(submitEvents, 5000);
        }
    };
    const createEvent = (type, details) => {
        const tabId = getTabId();
        const sessionId = getSessionId();
        const sessionSeq = getSessionSeq();
        const event = {
            id: crypto.randomUUID(),
            tabId,
            sessionId,
            sessionSeq,
            timestamp: Date.now(),
            eventCategory: sessionEventTypeCategories[type],
            eventType: type,
            details,
        };
        queue.push(event);
        recordSessionActivity();
        console.log('Created event', event);
        submit();
        return event;
    };
    return {
        createEvent,
    };
})();
//# sourceMappingURL=sessions.js.map